export const colors = [
  "#6f6f76",
  "#91babc",
  "#a7b5c6",
  "#c09a99",
  "#784b47",
  "#d4b687",
  "#bcb2af"
];
